import UserRewriterPromptsCard from '../../../components/UserRewriterPromptsCard';

export default function PromptsSection() {
  return <UserRewriterPromptsCard />;
}
